<template>
  <button class="lang-toggle" @click="toggle" :title="t('common.language')">
    <i class="mdi mdi-web"></i>
    <span>{{ currentLocale === 'en' ? 'EN' : 'SW' }}</span>
    <i class="mdi mdi-chevron-down"></i>
    <div v-if="open" class="lang-menu" @click.stop>
      <button v-for="l in availableLocales" :key="l.code"
              :class="{ active: currentLocale === l.code }"
              @click="pick(l.code)">
        <span class="flag">{{ l.flag }}</span> {{ l.label }}
      </button>
    </div>
  </button>
</template>

<script>
import { currentLocale, setLocale, availableLocales, t } from '@/i18n';

export default {
  name: 'LanguageToggle',
  data() { return { open: false, currentLocale: currentLocale.value, availableLocales }; },
  mounted() {
    this._onLoc = (e) => { this.currentLocale = e.detail; };
    window.addEventListener('paysol-locale-changed', this._onLoc);
    document.addEventListener('click', this.close);
  },
  beforeUnmount() {
    window.removeEventListener('paysol-locale-changed', this._onLoc);
    document.removeEventListener('click', this.close);
  },
  methods: {
    t,
    toggle(e) { e.stopPropagation(); this.open = !this.open; },
    close(e) { if (!e.target.closest('.lang-toggle')) this.open = false; },
    pick(loc) { setLocale(loc); this.open = false; },
  }
};
</script>

<style scoped>
.lang-toggle {
  position: relative;
  background: transparent; border: 1px solid rgba(255,255,255,0.15); color: inherit;
  padding: 6px 10px; border-radius: 6px; cursor: pointer;
  display: inline-flex; align-items: center; gap: 4px; font-weight: 600; font-size: 12px;
}
.lang-toggle:hover { background: rgba(255,255,255,0.05); }
.lang-toggle i.mdi-web { font-size: 15px; opacity: 0.7; }
.lang-toggle i.mdi-chevron-down { font-size: 14px; opacity: 0.6; }
.lang-menu {
  position: absolute; top: calc(100% + 6px); right: 0; min-width: 160px; z-index: 100;
  background: #fff; color: #111; border: 1px solid #ddd; border-radius: 6px;
  box-shadow: 0 8px 20px rgba(0,0,0,.25); padding: 4px;
}
.lang-menu button {
  display: flex; align-items: center; gap: 8px; width: 100%; padding: 8px 10px;
  background: transparent; color: #111; border: none; text-align: left; font-size: 13px;
  border-radius: 4px; cursor: pointer;
}
.lang-menu button:hover { background: #f2f4f8; }
.lang-menu button.active { background: rgba(42, 169, 171, 0.12); color: #1F8A8B; font-weight: 600; }
.flag { font-size: 14px; }
</style>
